import React from 'react';
import Callout from 'src/components/InformationCallout/Callout';
import FontAwesomeIcon from 'src/components/Icon/FontAwesomeIcon';

const KeyPickupHandedOffCard = () => (
  <Callout
    variant="success"
    icon={<FontAwesomeIcon glyph="check-circle" weight="solid" />}
    title="Keys handed off"
    subtitle="This unit's keys have already been handed off — the key pickup is complete."
  />
);

export default KeyPickupHandedOffCard;
